import {computed, Injectable, signal} from '@angular/core';

export type LoginTransitionPhase = 'idle' | 'covering' | 'exiting';

const COVER_ANIMATION_MS = 760;
const VIEWPORT_EXPANSION_MS = 820;
const FADE_ANIMATION_MS = 420;

@Injectable({ providedIn: 'root' })
export class LoginTransitionStore {
	private phase = signal<LoginTransitionPhase>('idle');

	readonly currentPhase = this.phase.asReadonly();
	readonly isCovered = computed(() => this.phase() === 'covering' || this.phase() === 'exiting');
	readonly isExiting = computed(() => this.phase() === 'exiting');

	cover() {
		this.phase.set('covering');
	}

	reveal() {
		this.phase.set('idle');
	}

	async exitToDashboard() {
		this.cover();
		await this.wait(COVER_ANIMATION_MS);

		this.phase.set('exiting');
		await this.wait(VIEWPORT_EXPANSION_MS + FADE_ANIMATION_MS);
	}

	private wait(durationMs: number) {
		return new Promise<void>(resolve => window.setTimeout(resolve, durationMs));
	}
}
